function InfoIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 20 20'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M9.99967 2.50065C5.85754 2.50065 2.49967 5.85851 2.49967 10.0007C2.49967 14.1428 5.85754 17.5006 9.99967 17.5006C14.1418 17.5006 17.4997 14.1428 17.4997 10.0007C17.4997 5.85851 14.1418 2.50065 9.99967 2.50065ZM0.833008 10.0007C0.833008 4.93804 4.93706 0.833984 9.99967 0.833984C15.0623 0.833984 19.1663 4.93804 19.1663 10.0007C19.1663 15.0633 15.0623 19.1673 9.99967 19.1673C4.93706 19.1673 0.833008 15.0633 0.833008 10.0007Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.0003 9.16602C10.4606 9.16602 10.8337 9.53911 10.8337 9.99935V13.3327C10.8337 13.7929 10.4606 14.166 10.0003 14.166C9.54009 14.166 9.16699 13.7929 9.16699 13.3327V9.99935C9.16699 9.53911 9.54009 9.16602 10.0003 9.16602Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M9.16699 6.66732C9.16699 6.20708 9.54009 5.83398 10.0003 5.83398H10.0087C10.4689 5.83398 10.842 6.20708 10.842 6.66732C10.842 7.12755 10.4689 7.50065 10.0087 7.50065H10.0003C9.54009 7.50065 9.16699 7.12755 9.16699 6.66732Z'
        />
      </svg>
    </span>
  );
}

export default InfoIcon;
